import React, { useContext, useEffect, useState } from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'

import styles from './preview.module.css'

import { colors } from './utils'

import { CalendarContext } from '../CalendarContext'
import { updateCalendar } from '@src/actions/calendar'
import CheckboxAndText from './components/CheckboxAndText'
import CustomDropDown from './components/CustomDropDown'
import { timezones } from './utils/constants'
import CalendarWeek from './Calendars/CalendarWeek'
import CalendarMonth from './Calendars/CalendarMonth'
import CalendarSchedule from './Calendars/CalendarSchedule'
import { apiUrl } from '@src/apiBackend'

const Preview = () => {
	const dispatch = useDispatch()
	const { handleShowToast } = useContext(CalendarContext)
	const { user } = useSelector((state) => state.user)
	const { selectedCalendarData, selectedCalendar } = useSelector(
		(state) => state.calendar
	)
	const [calendarTitle, setCalendarTitle] = useState(
		selectedCalendarData.calendarName
	)

	const [previewSettings, setPreviewSettings] = useState(
		selectedCalendarData?.previewSettings
	)
	const [selectedOption, setSelectedOption] = useState(
		selectedCalendarData?.previewSettings?.defaultCalendar || 'Mes'
	)

	const [hoveredColor, setHoveredColor] = useState(null)

	
	const updProp = (prop, newValue) => {
		const newValues = { ...previewSettings, [prop]: newValue }
		setPreviewSettings(newValues)

		dispatch(
			updateCalendar({
				userId: user.id,
				calendarId: selectedCalendar,
				toUpdate: { previewSettings: newValues },
			})
		).finally(() => handleShowToast())
	}

	const handleMouseEnter = (e, itemValue) => {
		const rect = e.target.getBoundingClientRect()
		setHoveredColor({ value: itemValue, top: rect.top + 5, left: rect.left })
	}

	useEffect(() => {
		setCalendarTitle(selectedCalendarData?.calendarName)
		setPreviewSettings(selectedCalendarData?.previewSettings)
		!selectedOption &&
			setSelectedOption(selectedCalendarData?.previewSettings?.defaultCalendar)
	}, [selectedCalendarData])


	if (Object.keys(selectedCalendarData).length === 0 || !previewSettings)
		return null
	return (
		<div className={styles.preview}>
			<div className={styles.left}>
				<div className={styles.title}>
					<input
						value={calendarTitle}
						onChange={(e) => setCalendarTitle(e.target.value)}
						type='text'
						placeholder='Titulo del calendario'
					/>
					<span>{calendarTitle?.length}/200</span>
					{calendarTitle !== selectedCalendarData.calendarName && (
						<button
							onClick={() => {
								dispatch(
									updateCalendar({
										userId: user.id,
										calendarId: selectedCalendar,
										toUpdate: { ['calendarName']: calendarTitle },
									})
								).finally(() => handleShowToast())
							}}
							className={styles.saveCalendarTitle}
						>
							Actualizar
						</button>
					)}
				</div>
				<div className={styles.options}>
					<b style={{ marginBottom: '5px' }}>Mostrar</b>
					<CheckboxAndText
						text={'Título'}
						state={previewSettings?.showTitle}
						setState={(option) => updProp('showTitle', option)}
					/>
					<CheckboxAndText
						text={'Botones de navegación'}
						state={previewSettings?.showNavButtons}
						setState={(option) => updProp('showNavButtons', option)}
					/>
					<CheckboxAndText
						text={'Fecha'}
						state={previewSettings?.showDate}
						setState={(option) => updProp('showDate', option)}
					/>
					<CheckboxAndText
						text={'Icono de imprimir'}
						state={previewSettings?.showPrint}
						setState={(option) => updProp('showPrint', option)}
					/>
					<CheckboxAndText
						text={'Lista de calendarios'}
						state={previewSettings?.showCalendarsList}
						setState={(option) => updProp('showCalendarsList', option)}
					/>
					<CheckboxAndText
						text={'Zona horaria'}
						state={previewSettings?.showTimeZone}
						setState={(option) => updProp('showTimeZone', option)}
					/>
				</div>
				<div className={styles.color}>
					<b>Color de fondo</b>
					<button
						onClick={() => updProp('backgroundColor', 'default')}
						className={styles.defaultBgButton}
					>
						Por defecto
					</button>
					<ul>
						{colors.map((item, index) => (
							<li
								onClick={() => updProp('backgroundColor', item.value)}
								onMouseEnter={(e) => handleMouseEnter(e, item.value)}
								onMouseLeave={() => setHoveredColor(null)}
								key={index}
							>
								<div
									className={styles.colorCard}
									style={{ background: item.value }}
								>
									<span>{item.name}</span>
									{hoveredColor && hoveredColor.value === item.value && (
										<div
											className={styles.tooltip}
											style={{
												top: `${hoveredColor.top - 30}px`,
												left: `${hoveredColor.left}px`,
											}}
										>
											{item.name}
										</div>
									)}
								</div>
							</li>
						))}
					</ul>
				</div>
				<CheckboxAndText
					text={'Borde'}
					state={previewSettings?.border}
					setState={(option) => updProp('border', option)}
				/>
				<div className={styles.form}>
					<CustomDropDown
						fullWidth={true}
						title='Vista predeterminada'
						placeholder='Selecciona una vista'
						options={['Semana', 'Mes', 'Agenda']}
						selectedOption={previewSettings?.defaultCalendar}
						setSelectedOption={(option) => {
							updProp('defaultCalendar', option)
							setSelectedOption(option)
						}}
					/>
					<CustomDropDown
						fullWidth={true}
						title='La semana empieza el'
						placeholder='Selecciona un dia'
						options={['Sábado', 'Domingo', 'Lunes']}
						selectedOption={previewSettings?.weekStarts}
						setSelectedOption={(option) => updProp('weekStarts', option)}
					/>
					<CustomDropDown
						fullWidth={true}
						title='Idioma'
						placeholder='Selecciona un idioma'
						options={['Español', 'Ingles']}
						selectedOption={previewSettings?.language}
						setSelectedOption={(option) => updProp('language', option)}
					/>
					{previewSettings?.showTimeZone && (
						<CustomDropDown
							fullWidth={true}
							title='Zona horaria'
							placeholder='Selecciona una zona horaria'
							options={timezones}
							selectedOption={previewSettings?.timezone}
							setSelectedOption={(option) => updProp('timezone', option)}
						/>
					)}
				</div>
				<div className={styles.shows}>
					<b>Calendarios mostrados</b>
					<CheckboxAndText
						text={selectedCalendarData.calendarName}
						state={selectedCalendarData.calendarName}
						onlyRead={true}
					/>
				</div>
			</div>
			<div className={styles.right}>
				<div className={styles.input}>
					<label>Insertar código</label>
					<input
						placeholder={`<iframe src="${apiUrl}/es/app/calendar/watchCalendar/${selectedCalendarData.shareId}"></iframe>`}
					/>
				</div>
				<small>
					Copia y pega el código HTML anterior para incluir este calendario en
					tu página web.
				</small>
				<div>
					<CalendarPreview
						selectedOption={selectedOption}
						setSelectedOption={setSelectedOption}
						calendarTitle={calendarTitle}
						previewSettings={previewSettings}
					/>
				</div>
			</div>
		</div>
	)
}

export default Preview

export const CalendarPreview = ({
	calendarTitle,
	previewSettings,
	selectedOption,
	setSelectedOption,
}) => {
	const { selectedCalendarData } = useSelector((state) => state.calendar)

	const {
		formattedMonth,
		handlePreviousMonth,
		handleNextMonth,
		setTodayAsSelectedDate,
		selectedDate,
	} = useContext(CalendarContext)
	
	return (
		<div
			style={{
				border: previewSettings.border ? `1px solid var(--border-color)` : '',
			}}
			className={styles.preview}
		>
			<div className={styles.header}>
				{previewSettings.showTitle && (
					<div
						style={{
							borderBottom: previewSettings.border
								? `1px solid var(--border-color)`
								: '',
						}}
						className={styles.title}
					>
						{selectedCalendarData.calendarName}
					</div>
				)}
				<div>
					<div>
						{previewSettings.showNavButtons && (
							<button
								onClick={setTodayAsSelectedDate}
								className={`${styles.toDay} ${
									selectedDate.day === new Date().getDate() &&
									selectedDate.month === new Date().getMonth() &&
									selectedDate.year === new Date().getFullYear()
										? styles.actualToday
										: ''
								}`}
							>
								Hoy
							</button>
						)}
						{previewSettings.showNavButtons && (
							<div className={styles.date}>
								<div>
									<button onClick={handlePreviousMonth}>
										<FaChevronLeft />
									</button>
									<button onClick={handleNextMonth}>
										<FaChevronRight />
									</button>
								</div>
							</div>
						)}
						{previewSettings.showDate && formattedMonth}
					</div>
					<div className={styles.buttons}>
						{previewSettings.showPrint && <button>Imprimir</button>}
						{previewSettings.showCalendarsList && (
							<button onClick={() => setSelectedOption('Semana')}>
								Semana
							</button>
						)}
						{previewSettings.showCalendarsList && (
							<button onClick={() => setSelectedOption('Mes')}>Mes</button>
						)}
						{previewSettings.showCalendarsList && (
							<button onClick={() => setSelectedOption('Agenda')}>
								Agenda
							</button>
						)}
					</div>
				</div>
			</div>
			<div className={styles.calendar}>
				{selectedOption === 'Mes' ? (
					<CalendarMonth fromPreview={true} previewSettings={previewSettings} />
				) : selectedOption === 'Semana' ? (
					<CalendarWeek fromPreview={true} previewSettings={previewSettings} />
				) : (
					<CalendarSchedule
						fromPreview={true}
						previewSettings={previewSettings}
					/>
				)}
			</div>
			<div className={styles.footer}>
				<p>
					Los eventos se muestran en la zona horaria: Hora de Europa central -
					Madrid
				</p>
				<div>FacturaGPT Calendar</div>
			</div>
		</div>
	)
}
